/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AggregateMetricsBase {
    getFixupPrototypeFunction() { return AggregateMetricsBase.fixupPrototype; }

    static newInstance(model: Partial<AggregateMetricsBase>): AggregateMetricsBase {
        let obj = Object.assign(new AggregateMetricsBase(), model);
        AggregateMetricsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AggregateMetricsBase>): AggregateMetricsBase {
        if (!model) return null;
        return AggregateMetricsBase.newInstance(<AggregateMetricsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AggregateMetricsBase) {
        if (!obj) return;

        models.AggregateMetricsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AggregateMetricsBase): boolean {
        Object.setPrototypeOf(obj, AggregateMetricsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the metric
     */
    metric_name: string;

    /**
     * Name of the model
     */
    model_name: string;

    /**
     * Type of the model
     */
    model_type: string;

    /**
     * Category of the resource
     */
    resource_category: string;

    /**
     * unit of measures
     */
    unit: string;

}
